import React, { FunctionComponent } from "react";
// @ts-ignore
import useCollapse from "react-collapsed";
import { ILink } from "./interfaces";
import { Link } from "react-router-dom";

const MobileNavbarDropdownLink: FunctionComponent<{ link: ILink }> = ({
  link,
}) => {
  const { getCollapseProps, getToggleProps, isOpen } = useCollapse();

  return (
    <li className="text-white px-8 uppercase font-poppins text-xs">
      <div className="flex w-full justify-between py-3">
        <Link to={link.href}>{link.text}</Link>
        <i className="icon-angle-right px-2" {...getToggleProps()} type="" />
      </div>
      <ul className="px-2" {...getCollapseProps()}>
        {link.sublinks &&
          link.sublinks.map((sublink, index) => (
            <li key={index} className="py-3">
              {sublink.external ? (
                <a href={sublink.href} target="_blank">
                  {sublink.text}
                </a>
              ) : (
                <Link to={sublink.href}>{sublink.text}</Link>
              )}
            </li>
          ))}
      </ul>
    </li>
  );
};

export default MobileNavbarDropdownLink;
